import NonHazardousWaste from '../components/NonHazardousWaste';

function NonHazardousWastePage() {
  return <NonHazardousWaste />;
}

export default NonHazardousWastePage;
